import { combineEpics } from "redux-observable";
import { epicTournamentGetCollectLeagueRankings } from "./epics/epicTournamentGetCollectLeagueRankings";
import { epicTournamentGetCoopRankings } from "./epics/epicTournamentGetCoopRankings";
import { epicTournamentGetPlayerRankings } from "./epics/epicTournamentGetPlayerRankings";
import { epicTournamentGetRankings } from "./epics/epicTournamentGetRankings";
import { epicTournamentRequestPackageFromCurrentReward } from "./epics/epicTournamentRequestPackageFromCurrentReward";
import { epicTournamentSelectDialog } from "./epics/epicTournamentSelectDialog";
export var epicTournaments = combineEpics(epicTournamentSelectDialog, epicTournamentGetRankings, epicTournamentRequestPackageFromCurrentReward, epicTournamentGetCoopRankings, epicTournamentGetPlayerRankings, epicTournamentGetCollectLeagueRankings);



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/epicTournaments.ts
// module id = 2440
// module chunks = 3